import { render } from "./akri-work-setting-view.vue?vue&type=template&id=39c1c3ce&class=d-flex"
import script from "./akri-work-setting-view.vue?vue&type=script&setup=true&lang=js"
export * from "./akri-work-setting-view.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/arki/views/work-settings/akri-work-setting-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "39c1c3ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('39c1c3ce', __exports__)) {
    api.reload('39c1c3ce', __exports__)
  }
  
  module.hot.accept("./akri-work-setting-view.vue?vue&type=template&id=39c1c3ce&class=d-flex", () => {
    api.rerender('39c1c3ce', render)
  })

}


export default __exports__